export const cilDinner = ["24 24","<path d='M21.75 16.128c0-5.124-3.973-9.337-9-9.721v-2.657h-1.5v2.657c-5.027 0.384-9 4.598-9 9.721v1.552h19.5zM20.25 16.18h-16.5v-0.052c0-4.549 3.701-8.25 8.25-8.25s8.25 3.701 8.25 8.25z'></path><path d='M0.75 19.5h22.5v1.5h-22.5v-1.5z'></path>"]


//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/icons/js/free/cil-dinner.js
// module id = null
// module chunks = 